import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { StatusPill } from 'components/Pills/StatusPills';

import styles from './ToggleSwitch.module.scss';

export const ToggleSwitch = ({
  label,
  name,
  className,
  tooltip,
  inputProps,
  disabled = false,
  register = () => {},
  status = null,
  defaultValue = false,
  noMargin = false,
  usePrimaryColor = false,
  dataTestId,
}) => {
  // Ensure defaultValue is always a boolean (never undefined) to avoid controlled/uncontrolled warning
  // This matches backend behavior where toggle_switch defaults to false if not set
  const safeDefaultValue =
    defaultValue !== undefined && defaultValue !== null ? Boolean(defaultValue) : false;

  return (
    <div className={cn(styles.root, { [className]: className, [styles.rootNoMargin]: noMargin })}>
      <div className="d-flex align-items-center u-gap">
        {label && (
          <label>
            {label}
            {tooltip && (
              <OverlayTrigger placement="bottom" overlay={<Tooltip>{tooltip}</Tooltip>}>
                <div className={styles.tooltip}>
                  <FeatherIcon icon="help-circle" />
                </div>
              </OverlayTrigger>
            )}
          </label>
        )}
        {status && (
          <StatusPill text={status.text} status={status.status} className={styles.status} />
        )}
      </div>

      <div className={cn(styles.slider, { [styles.sliderPrimaryColor]: usePrimaryColor })}>
        <input
          disabled={disabled}
          type="checkbox"
          {...register(name)}
          // Only use defaultChecked if inputProps doesn't have checked (controlled)
          // If inputProps has checked, it's controlled and we shouldn't use defaultChecked
          // Extract checked from inputProps to avoid setting both checked and defaultChecked
          {...(inputProps?.checked !== undefined
            ? { ...inputProps }
            : { ...inputProps, defaultChecked: safeDefaultValue })}
          data-testid={dataTestId}
        />
        <span></span>
      </div>
    </div>
  );
};

ToggleSwitch.propTypes = {
  label: PropTypes.string,
  register: PropTypes.func,
  name: PropTypes.string,
  className: PropTypes.string,
  inputProps: PropTypes.object,
  defaultValue: PropTypes.bool,
};
